import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Switch, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PlayCircleFilledRoundedIcon from '@mui/icons-material/PlayCircleFilledRounded';
import PauseCircleFilledOutlinedIcon from '@mui/icons-material/PauseCircleFilledOutlined';
import StopIcon from '@mui/icons-material/Stop';

import colors from '../../../../../../constants/colors';

const ActiveSwitch = ({ stopped, switchStatus, handleActiveSwitch, referenceValue }) => {
	const [isLoading, setIsLoading] = useState(false);
	const paused = stopped ? '"Paused"' : '"Stopped"';

	const useStyles = makeStyles({
		root: {
			width: '65px',
			height: '20px',
			padding: '0px'
		},
		switchBase: {
			color: '#818181',
			padding: '1px',
			'&$checked': {
				'& + $track': {
					backgroundColor: colors.blue
				}
			},
			'&$disabled + $track': {
				opacity:  0.12,
			},
			'&$disabled': {
				color: colors.disabled,
			},
		},
		disabled: { },
		track: {
				borderRadius: '20px',
				backgroundColor: stopped ? colors.grey : colors.warning,
				opacity: '1 !important',
				'&:after, &:before': {
					fontSize: '10px',
					position: 'absolute',
					top: '5px'
				},
				'&:after': {
					content: switchStatus ? '"Active"' : '',
					left: '5px',
					color: colors.white
				},
				'&:before': {
					content: !switchStatus ? paused : '',
					right: '6px',
					color: stopped ? colors.black : colors.white
				}
		},
		checked: {
			transform: 'translateX(46px) !important'
		},
		playIcon: {
			color: colors.white,
			width: '18px',
			height: '18px'
		},
		pauseIcon: {
			color: stopped ? colors.black : colors.white,
			width: '18px',
			height: '18px'
		},
		input: {
			width: '64px',
			left: !switchStatus ? '0' : '-220%'
		}
	});
	const classes = useStyles();

	const toggleDisabledState = () => setIsLoading(!isLoading);

	const handleChange = (e, status) => handleActiveSwitch(status, referenceValue, toggleDisabledState);

	return (
		<div>
			{!isLoading ?
				<Switch
					classes={{
						root: classes.root,
						switchBase: classes.switchBase,
						thumb: classes.thumb,
						track: classes.track,
						checked: classes.checked,
						disabled: classes.disabled,
						input: classes.input
					}}
					checked={switchStatus}
					onChange={handleChange}
					icon={!stopped ? <StopIcon className={classes.pauseIcon} /> 
					: <PauseCircleFilledOutlinedIcon className={classes.pauseIcon} />}
					checkedIcon={<PlayCircleFilledRoundedIcon className={classes.playIcon} />}
				/>
			:	<CircularProgress size='2rem' />
			}
		</div>
	);
}

ActiveSwitch.propTypes = {
	handleActiveSwitch: PropTypes.func.isRequired,
	switchStatus: PropTypes.bool.isRequired,
	referenceValue: PropTypes.number.isRequired,
	stopped: PropTypes.bool.isRequired
}

export default ActiveSwitch;